// Styles here will override Bulma styles
import { css } from '@emotion/core';

export const ulStyled = css`
  margin: 0;

  li {
    margin-bottom: 10px;
  }
`;

export const headingStyled = css`
  color: #080c2d;
  font-size: 20px;
  line-height: 28px;
  text-align: left;
`;
